// extracted by mini-css-extract-plugin
export default {"wrapper":"v2-z","play":"w2-z"};